export enum USER_PROFILE_ENUM {
  LOGOUT = "logout",
  PROFILE = "profile",
  USER = "User",
  MANAGE_CREDENTIAL = "manage-credential",
  TOGGLE_OFF = "toggle_off",
  USER_CONNECT = "user_connect",
  MANAGE_ACCOUT = "manage_accounts",
  MANAGE_SALES = "supervisor_account",
  MANAGE_PLATE = "manage-plate",
}
